import { IconSettings } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const settingsModule: ModuleDefinition = {
  id: 'settings',
  i18nNamespace: 'settings',
  requires: { subject: 'business', action: 'read' },

  nav: {
    labelKey: 'settings:nav',
    icon: IconSettings,
    to: 'settings',
    group: 'manage',
    order: 20,
  },

  routes: [{ path: 'settings', component: () => import('./SettingsPage') }],
};
